export const PROPERTY_GRID_SUBJECT_PROPERTY = 'subject';
